import { render, staticRenderFns } from "./LookCompetitionDetail.vue?vue&type=template&id=e8748ba4&scoped=true&"
import script from "./LookCompetitionDetail.vue?vue&type=script&lang=js&"
export * from "./LookCompetitionDetail.vue?vue&type=script&lang=js&"
import style0 from "./LookCompetitionDetail.vue?vue&type=style&index=0&id=e8748ba4&prod&scoped=true&lang=css&"
import style1 from "./LookCompetitionDetail.vue?vue&type=style&index=1&id=e8748ba4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8748ba4",
  null
  
)

export default component.exports